export default {
  title: {
    id: 'product_page_ecoblock_title',
    defaultMessage: 'Buying renewed vs. new',
  },
  subtitle: {
    id: 'product_page_ecoblock_subtitle',
    defaultMessage:
      'Here’s the environmental damage you’re preventing by choosing a renewed smartphone over a brand new one.',
  },
  card1Title: {
    id: 'product_page_ecoblock_card1_title',
    defaultMessage: '190 lbs of CO2e',
  },
  card1Description: {
    id: 'product_page_ecoblock_card1_description',
    defaultMessage: 'That’s like driving an SUV from NYC to Chicago.',
  },
  card2Title: {
    id: 'product_page_ecoblock_card2_title',
    defaultMessage: '6 oz of e-waste',
  },
  card2Description: {
    id: 'product_page_ecoblock_card2_description',
    defaultMessage: 'That’s around the weight of a baseball.',
  },
  card3Title: {
    id: 'product_page_ecoblock_card3_title',
    defaultMessage: '683 lbs of raw materials',
  },
  card3Description: {
    id: 'product_page_ecoblock_card3_description',
    defaultMessage: 'That’s like 20 dogs digging in your yard for a week.',
  },
  card4Title: {
    id: 'product_page_ecoblock_card4_title',
    defaultMessage: '21,741 gallons of water',
  },
  card4Description: {
    id: 'product_page_ecoblock_card4_description',
    defaultMessage: 'That’s like running a faucet for 3 days.',
  },
  modalLinkText: {
    id: 'product_page_ecoblock_modal_link_text',
    defaultMessage: 'See how renewed phones help the planet',
  },
}
